module.exports = __webpack_public_path__ + "static/media/Dashboard.f0a72729.svg";